module.exports = __webpack_public_path__ + "img/DropDownLists.9c0a5992.svg";